export default "__VITE_ASSET__BkDcqPG6__"